import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../index';

export const last5weeks = createSelector(
    (state:RootState)=>state.weeks.rows,
    (weeks)=>weeks.slice(0,5)
);
